import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'app-quick-response',
    templateUrl: './quick-response.component.html',
    styleUrls: ['./quick-response.component.css'],
    animations: [
        trigger('animateButtons', [
            state('Active', style({ transform: 'translateY(0) scale(1)' })),
            state('Inactive', style({ transform: 'translateY(0) scale(1)' })),
            transition('* => Active', [
                style({ transform: 'translateY(100%) scale(1)' }),
                animate(400),
            ])
        ])
    ],
    standalone: false
})
export class QuickResponseComponent implements OnInit {

  @Input() quickResponseButtonSetInput: any;
  @Input() requestInProgress = false;
  @Output() selectedResponse = new EventEmitter();
  animateButtons = this.requestInProgress ? 'Inactive' : 'Active';

  constructor() { }

  ngOnInit() {
  }

  // Implement this generic event handler for all button clicks.
  onButtonClick(btn: any): void {
    if (this.requestInProgress) {
      return;
    }

    // use event emitter to send specific expected response back.
    this.selectedResponse.emit(btn);

    event.preventDefault();
  }

  setClass(text: string): string {
    return 'col-' + Math.ceil(text.length / 10);
  }

}
